/* eslint-disable quotes, quote-props, comma-dangle  */
import type { TranslationProps } from './types';

export const translations = {
  "cancel_button_label": [
    {
      "type": 0,
      "value": "Annulla"
    }
  ],
  "warning_body_list_item_one": [
    {
      "type": 0,
      "value": "Hai ottenuto la giustificazione aziendale per l'accesso ai dati dei clienti"
    }
  ],
  "warning_body_list_item_two": [
    {
      "type": 0,
      "value": "La tua attività di download verrà registrata e tracciata per motivi di conformità alla sicurezza"
    }
  ],
  "warning_footer": [
    {
      "type": 0,
      "value": "Desideri procedere?"
    }
  ],
  "warning_header": [
    {
      "type": 0,
      "value": "Effettuando il download, acconsenti a quanto segue:"
    }
  ]
};

function TranslationProviderComponent({ children }: TranslationProps) {
  return children(translations);
}

export default Object.assign(TranslationProviderComponent, { translations });
